import { Facet } from '../models/Facet';

/**
 * Facet which indicates whether a group is collapsed by default.
 */
export const defaultCollapsedFacet: Facet<boolean> = new Facet('defaultCollapsed');

/**
 * Facet which indicates the count of items in a group.
 */
export const countFacet: Facet<number> = new Facet('count');

/**
 * Facet which indicates that an item is a group.
 */
export const isGroupFacet: Facet<boolean> = new Facet('isGroup');

/**
 * Facet which indicates whether items can be dropped into the group.
 */
export const isDropEnabledFacet: Facet<boolean> = new Facet('isDropEnabled');

/**
 * The default limit for the number of items to display in a group.
 */
export const GROUP_ITEM_LIMIT = 30;

export const foldersGroupFacet: Facet<{}> = new Facet('foldersGroup');

export const documentsGroupFacet: Facet<{}> = new Facet('documentsGroup');

export const mediaGroupFacet: Facet<{}> = new Facet('mediaGroup');
